/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
    require("admin-lte");
} catch (e) {}

function closeMobileSidebar() {
    document.body.classList.remove("app-nav-open");
}

function collapseSidebarMenus() {
    if (!window.$) {
        return;
    }

    const $sidebar = $(".app-sidebar");

    $sidebar.find(".app-nav-children").each(function () {
        $(this).collapse("hide").removeClass("show");
        this.style.height = "";
    });

    $sidebar
        .find('[data-toggle="collapse"][aria-controls]')
        .attr("aria-expanded", "false")
        .addClass("collapsed");

    document.body.classList.add("app-sidebar-menus-ready");
}

function toggleAppSidebar() {
    if (window.innerWidth <= 1024) {
        document.body.classList.toggle("app-nav-open");
        return;
    }

    document.body.classList.toggle("app-sidebar-collapsed");

    try {
        localStorage.setItem(
            "appSidebarCollapsed",
            document.body.classList.contains("app-sidebar-collapsed")
                ? "1"
                : "0"
        );
    } catch (e) {}
}

try {
    if (
        localStorage.getItem("appSidebarCollapsed") === "1" &&
        window.innerWidth > 1024
    ) {
        document.body.classList.add("app-sidebar-collapsed");
    }
} catch (e) {}

document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.querySelector("[data-app-sidebar-toggle]");
    const close = document.querySelector("[data-app-sidebar-close]");

    if (toggle) {
        toggle.addEventListener("click", toggleAppSidebar);
    }

    if (close) {
        close.addEventListener("click", closeMobileSidebar);
    }

    document.querySelectorAll(".app-sidebar a").forEach(function (link) {
        link.addEventListener("click", function () {
            if (
                window.innerWidth <= 1024 &&
                !link.hasAttribute("data-toggle")
            ) {
                closeMobileSidebar();
            }
        });
    });

    collapseSidebarMenus();
    setTimeout(collapseSidebarMenus, 0);
    setTimeout(collapseSidebarMenus, 250);
});

window.addEventListener("resize", function () {
    if (window.innerWidth > 1024) {
        closeMobileSidebar();
    }
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import "./echo";
